"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = function (courseTitle) {
    return ((courseTitle + "").match(/^[^(]*/g) || [""])[0].trim();
};
//# sourceMappingURL=cleanCourseTitle.js.map


//////////////////
// WEBPACK FOOTER
// ../validation/build/pathValidations/utils/cleanCourseTitle.js
// module id = 460
// module chunks = 22